import React from 'react';
import { Button } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { getCorrectPath } from '../../../../common/utils/utils.js';
import Btn from './Button.js';

const ButtonBar = (props) => {

  // TODO move this logic out ouf here
  const onClick = (e, {path}) => {
    props.history.push(getCorrectPath(props.location.pathname + path));
  };

  return (
    <div>
      <Button.Group widths='2'>
        <Btn
          show={props.registrationEnabled}
          inverted={false}
          tkey={props.registrationEnabled ? 'reg.open' : 'reg.closed'}
          path='/register'
          onClick={onClick}
        />
        <Button.Group widths='2'>
          <Btn
            show={!!props.hasResults}
            inverted={true}
            tkey='results'
            path='/results'
            onClick={onClick}
          />
          <Btn
            show={true}
    //show={!!props.hasSchedule}
            inverted={true}
            tkey='schedule'
            path='/schedule'
            onClick={onClick}
          />
        </Button.Group>

      </Button.Group>
    </div>
  );
};

export default withRouter(ButtonBar);



// WEBPACK FOOTER //
// ./src/public/components/EventsList/Event/ButtonBar.js